"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const options_1 = require("../options");
const refreshJWT_1 = (0, tslib_1.__importDefault)(require("../apollo/refreshJWT"));
const repeatWithHeaders_1 = (0, tslib_1.__importDefault)(require("./repeatWithHeaders"));
function default_1({ networkError, operation, forward }) {
    if (!operation || !forward)
        return;
    return (0, repeatWithHeaders_1.default)(async () => {
        await (0, refreshJWT_1.default)((0, options_1.getOptions)());
    }, {
        operation,
        forward
    });
}
exports.default = default_1;
